import React from 'react';
import Aux from '../../Hoc/Aux/Aux';
import Hero from '../UI/Hero/Hero';
import curriculumImg from '../../Assets/Images/img19.png';
import Footer from '../Footer/Footer';
import Courses from '../Courses/Courses';

const curriculum = (props) => {
    return(
        <Aux>
            <Hero title="Industry Tested Curriculum"
                  classType="hero-overview"
                  img={curriculumImg}
            />

            <Aux>
                <Courses />
            </Aux>
            <Aux>
                <Footer />
            </Aux>
        </Aux>
    )
};

export default curriculum;


// WEBPACK FOOTER //
// ./src/Components/Curriculum/Curriculum.js